import { useRouter } from "next/router";
import { Add1Icon, SignIcon } from "@/components/common/icons";
import PageHead from "@/components/common/PageHead";
import { Divider, Menu, Button } from "@mantine/core";
import EmptyContent from "@/components/common/EmptyContent";

import MenuLayout from "@/components/common/MenuLayout";
import useAccount from "@/hooks/useAccount";
import useMyCampaigns from "@/airdrop/hooks/useMyCampaigns";
import { useNetwork, useSwitchNetwork } from "wagmi";
import CampaignRowItem from "@airdrop/components/CampaignRowItem";
import { RiCopperCoinLine } from "react-icons/ri";
import { AiOutlinePicture } from "react-icons/ai";
import { isMaintenance } from "@/config/config";
import networkMapping from "@/chain-info/map.json";

import type { NextPage } from "next";

const Dashboard: NextPage = () => {
  const router = useRouter();
  const { login, isLogin } = useAccount();
  const { chain } = useNetwork();
  const isChainSupport = (networkMapping as any)[String(chain?.id)];
  const { campaigns, loading } = useMyCampaigns(
    isLogin && isChainSupport ? chain?.id : undefined
  );
  const { switchNetwork } = useSwitchNetwork();

  return (
    <MenuLayout>
      <PageHead></PageHead>
      <div className="px-5 sm:px-[7vw]">
        <div
          className={`max-w-[1100px] mx-auto mt-6 ${
            isMaintenance ? "sm:mt-8" : "sm:mt-14"
          } px-5 md:px-0 flex items-center justify-between flex-wrap`}
        >
          <div>
            <div className="text-header font-bold text-dark1">Airdrops</div>
          </div>
          {isChainSupport && (
            <div className="flex items-center">
              <Menu
                trigger="hover"
                classNames={{
                  dropdown: "!w-[134px]",
                }}
              >
                <Menu.Target>
                  <div className="flex items-center h-10 w-36 justify-center border-none  bg-primary rounded-full ml-2 hover:cursor-pointer hover:bg-primary/80">
                    <Add1Icon className="fill-white w-5"></Add1Icon>
                    <div className="text-white font-semibold ml-2">
                      Create new
                    </div>
                  </div>
                </Menu.Target>
                <Menu.Dropdown>
                  <Menu.Item
                    icon={<RiCopperCoinLine size={14}></RiCopperCoinLine>}
                    onClick={() => {
                      router.push("/dashboard/airdrops/create?type=TOKEN");
                    }}
                  >
                    Token
                  </Menu.Item>
                  <Menu.Item
                    icon={<AiOutlinePicture size={14}></AiOutlinePicture>}
                    onClick={() => {
                      router.push("/dashboard/airdrops/create?type=NFT");
                    }}
                  >
                    NFT
                  </Menu.Item>
                </Menu.Dropdown>
              </Menu>
            </div>
          )}
        </div>
        <Divider className="border-gray2  my-6"></Divider>
        {!isChainSupport && isLogin && (
          <div className="flex flex-col items-center justify-center w-full mt-[156px]">
            <EmptyContent desc={`${chain?.name} not support`}></EmptyContent>
            <Button
              className="mt-6"
              onClick={() => {
                // @ts-ignore
                switchNetwork(1);
              }}
            >
              Switch network
            </Button>
          </div>
        )}
        {isChainSupport && campaigns.length === 0 && (
          <div className="flex justify-center w-full mt-[156px]">
            <EmptyContent desc="There’s nothing here yet"></EmptyContent>
          </div>
        )}
        <div className="max-w-[1100px] mx-auto pb-10">
          {campaigns.map((item, index) => (
            <CampaignRowItem key={index} campaign={item} />
          ))}
        </div>
      </div>
    </MenuLayout>
  );
};

export default Dashboard;
